<template>
  <div
    class="mt-4 bg-brand-gray-900 grid grid-cols-2"
    :style="gridRows"
    :class="{'grid-cols-1 justify-center': center, 'md:grid-cols-4': !center}"
  >
    <PartnersCard v-editable="partner" v-for="partner in partners" :key="partner._uid" class="h-[96px] p-4 flex justify-center items-center border border-[#525A58]">
      <a :href="partner.href" target="_blank">
        <img class="object-contain max-w-[120px]" :src="partner.src.filename" :alt="partner.name" />
      </a>
    </PartnersCard>

    <slot />

  </div>
</template>

<script>

import PartnersCard from './PartnersCard.vue';

export default {

    components: {
        PartnersCard
    },

    props: {
        partners: {
            type: Array,
            default: () => []
        },

        center: {
          type: Boolean,
          default: false
        }
    },

    computed: {
        gridRows() {

            let rowsCount = this.partners.length / 4;


            return {
                gridTemplateRows: `repeat(${rowsCount}, minmax(0, 1fr))'`
            }
        }
    }
};
</script>

<style>
</style>
